export default {
    total:{
        certified: 'ได้รับการรับรอง',
        UnCertified: 'ไม่ได้รับการรับรอง',
        login: 'เข้าสู่ระบบ',
        register: 'ลงทะเบียน',
        registerNow: 'ลงทะเบียนเดี๋ยวนี้',
        loginNow: 'เข้าสู่ระบบเดี๋ยวนี้',
        buyNow: 'ซื้อเดี๋ยวนี้',
        Currency: 'สกุลเงิน',
        chang24: 'เปลี่ยน',
        NowPrice: 'ราคาล่าสุด',
        Leverage: 'เลเวอเรจ',
        Favorites: 'รายการโปรด',
        Announcement:'ประกาศ',
        dynamic:'ไดนามิก',
        VerificationCode:'รหัสยืนยัน',
        enteremailcode:'โปรดใส่รหัสยืนยันทางอีเมล',
        GetCode:'ส่ง',
        add:'เพิ่ม',
        help: 'ศูนย์ช่วยเหลือ',
        xszy: 'คู่มือสำหรับผู้เริ่มต้น',
        jyzn: 'คู่มือการซื้อขาย',
        aboutUs: 'เกี่ยวกับ aaaa'
    },
    login:{
        loginTitle: 'ยินดีต้อนรับสู่ aaaa',
        email: 'อีเมล',
        enailTest: 'โปรดป้อนอีเมลของคุณ',
        password: 'รหัสผ่าน',
        passwordTest: 'โปรดป้อนรหัสผ่านของคุณ',
        unpassword: 'ลืมรหัสผ่าน?',
        noassets: 'ยังไม่มีบัญชี',
        Addassets: 'สร้างบัญชี',
        password2: 'ป้อนรหัสผ่านอีกครั้ง',
        password2test: 'โปรดป้อนรหัสผ่านอีกครั้ง',
        assets: 'บัญชีที่มีอยู่'
    },
    topHeader: {
        nav01: 'สัญญา',
        nav02: 'การซื้อขายสด',
        nav03: 'วินาที',
        nav04: 'คัดลอกการซื้อขาย',
        nav05: 'ข่าว',
        nav06: 'เปลี่ยนแปลงอย่างรวดเร็ว',
        APPStore: 'App Store',
        GooglePlay: 'Google Play',
        Android: 'Android',
        IOSaAndroid: 'IOS และ Android สแกนเพื่อดาวน์โหลด',
        cn: 'ภาษาจีนตัวย่อ',
        en: 'ภาษาอังกฤษ',
        assetsHome: 'สินทรัพย์',
        assets01: 'รายละเอียดสินทรัพย์',
        assets02: 'รายละเอียดเงินทุน',
        assets03: 'รายละเอียดคำสั่งซื้อ',
        assetsHome02: 'คำสั่งซื้อ',
        assets0201: 'สัญญา',
        assets0202: 'สด',
        assets0203:'วินาที',
        account01: 'ภาพรวม',
        account02: 'บัญชีและความปลอดภัย',
        account03: 'จัดการการคัดลอกการซื้อขาย',
        account04: 'จัดการการนำทางการซื้อขาย',
        loginOut: 'ออกจากระบบ'
    },
    foote:{
        test: 'aaaa เป็นแพลตฟอร์มบริการทางการเงินดิจิตอลชั้นนำระดับโลกที่ให้บริการการลงทุนทรัพย์สินดิจิตอลในสภาพแวดล้อมที่ปลอดภัย อัจฉริยะ และเชิงยุทธศาสตร์ผ่านบริการการลงทุนดิจิตอลแบบครบวงจร เครื่องมือการจัดสรรสินทรัพย์หลากหลายรูปแบบ บริการที่ให้คำปรึกษาการลงทุนนวัตกรรมและความเป็นผู้นำในวงการ รวมทั้งความเป็นผู้นำในการเปิดเผยสภาพคล่องของตลาด ทีมหลักของ aaaa เป็นผู้มีความชำนาญจากอุตสาหกรรมหลักทางการเงินและหลักทางอินเทอร์เน็ตชั้นนำเช่น Microsoft และองค์กรด้านการเงินดิจิตอลอื่น ๆ เพื่อนำเสนอประสบการณ์ที่มีความสร้างสรรค์ในการซื้อขายทางการเงินดั้งเดิม การพัฒนาแพลตฟอร์มสำหรับการแลกเปลี่ยนสกุลเงินดิจิตอลระดับสูง และการดำเนินงานในตลาดระดับโลก ตั้งแต่ก่อตั้งเมื่อหกเดือนที่ผ่านมา ผู้ใช้งานทั่วโลกได้เกิน 100,000 คนและครอบคลุมมากกว่า 80 ประเทศและภูมิภาค รวมถึงทวีปเอเชียแปซิฟิก เอเชียเเละยุโรป',
        tab1Title1: 'ช่วยเหลือ',
        tab1Test1: 'คำถามที่พบบ่อย',
        tab1Test2: 'ศูนย์ประกาศ',
        tab2Title1: 'ข้อกฏกติกา',
        tab2Test1: 'ข้อกำหนดการให้บริการ',
        tab2Test2: 'นโยบายความเป็นส่วนตัว',
        tab2Test3: 'การเปิดเผยความเสี่ยง',
        tab3Title1: 'ร่วมงานกับเรา',
        msg: 'คำเตือนเกี่ยวกับความเสี่ยง: การซื้อขายทรัพย์สินดิจิตอลเป็นอุตสาหกรรมในระยะเริ่มต้นที่มีโอกาสสำคัญ แต่ก็มีความเสี่ยงที่สูงเนื่องจากลักษณะใหม่ของมัน โดยเฉพาะอย่างยิ่งในการซื้อขายสัญญา เลเวอเรจทำให้กำไรและความเสี่ยงสูงพร้อมกัน สำคัญที่จะมีความเข้าใจรอบคอบเกี่ยวกับอุตสาหกรรม เครื่องแบบการซื้อขายสัญญา กฎเกณฑ์การซื้อขาย และความรู้ที่เกี่ยวข้องอื่น ๆ ก่อนที่จะมีส่วนร่วม ขอแนะนำให้คุณซื้อขายภายใต้ขีด จำกัด ที่คุณสามารถรับได้ การซื้อขายเป็นเรื่องที่เสี่ยง และควรระมัดระวังเมื่อเข้าสู่ตลาด!',
        banquan: 'ลิขสิทธิ์',
        banquan2: 'สงวนลิขสิทธิ์ทั้งหมด',
        aboutUs: 'เกี่ยวกับเรา',
        Platform:'บทนำแพลตฟอร์ม'
    },
    home:{
        bannerTitle: 'ซื้อคริปโตใน aaaa',
        bannerTest: 'แลกเปลี่ยนการซื้อขายเหรียญสกุลดิจิตอลชนิดเอสโซเชียลชั้นนำของโลก',
        changUpRank: 'อันดับผู้กำไรสูง',
        changDownRank: 'อันดับผู้ขาดทุนสูง',
        whyTitle: 'ทำไมต้องเลือกเรา',
        indexTitle1: 'การรับประกันความปลอดภัย',
        indexTest1: 'การกระจายทั่วโลกโดยไม่มีความเสี่ยงระบบ',
        indexTitle2: 'พันธกิจและวิสัยทัศน์',
        indexTest2: 'ให้นักลงทุนเพลิดเพลินกับกำไรจากคริปโตสกุล',
        indexTitle3: 'สมาร์ทคอนแทรค',
        indexTest3: 'การซื้อขายแบบยาวและแบบสั้น วางคำสั่งอย่างรวดเร็ว สูงสุดถึงการเลเวอเรจ 100 เท่า',
        indexTitle4: 'การคัดลอกการซื้อขาย',
        indexTest4: 'คลิกเพียงครั้งเดียวเพื่อติดตามการซื้อขายจากนักเทรดชั้นนำที่มีอัตราผลตอบแทนสูง',
        indexTitle5: 'การสนทนาแบบเรียลไทม์',
        indexTest5: 'การสนทนาแบบเรียลไทม์',
        indexTitle6: 'ไบนารี่',
        indexTest6: 'ดัชนีเหรียญสกุลดิจิตอลแบบไบนารี่เป็นของโลกครั้งแรก',
        indexTitle7: 'สกุลเงินหลายรูปแบบ',
        indexTest7: 'เข้าใจอย่างมั่นใจถึงความสำคัญในโครงการหลากหลายรูปแบบกว่า 300 โครงการ',
        indexTitle8: 'นิเวศ',
        indexTest8: 'สร้างบริการครบวงจรสำหรับการแลกเปลี่ยนเหรียญสกุลดิจิตอล กระเป๋าเงินและนิเวศบนเชื่อมโยง',
        downLoadTitle: 'ซื้อขายทุกที่ ทุกเวลา',
        downLoadTest: 'สามารถใช้งานได้บนอุปกรณ์ iOS, Android และ PC ซื้อขายทุกที่ทุกเวลา',
        downLoadCode: 'สแกนเพื่อดาวน์โหลด',
        downLoadIosAnd: 'iOS และ Android'
    },
    contract:{
        Change: 'การเปลี่ยนแปลงในช่วง 24 ชั่วโมง',
        High: 'ราคาสูงสุดในช่วง 24 ชั่วโมง',
        Low: 'ราคาต่ำสุดในช่วง 24 ชั่วโมง',
        Volume24: 'ปริมาณการซื้อขายในช่วง 24 ชั่วโมง',
        Market: 'ตลาด',
        LimitPrice: 'ราคาจำกัด',
        BestPrice: 'ซื้อขายในราคาที่ดีที่สุด',
        EnterPrice: 'โปรดป้อนราคา',
        Amount: 'จำนวน',
        Margin: 'มาร์จิ้น',
        Available: 'ยอดเงินที่ใช้ได้',
        Leverage: 'การเลเวอเรจ',
        Fee: 'ค่าธรรมเนียมการทำธุรกรรม',
        Buy: 'ซื้อ',
        Long: 'Long',
        Sell: 'ขาย',
        Short: 'Short',
        Assets: 'สินทรัพย์',
        ContractAssets: 'สินทรัพย์สัญญา',
        Deposit: 'ฝากเงินเข้า',
        Login: 'เข้าสู่ระบบบัญชีการซื้อขาย',
        Register: 'ลงทะเบียนบัญชีการซื้อขาย',
        Instrument: 'เครื่องมือการซื้อขาย',
        Minimum: 'ขนาดสินค้าขั้นต่ำ',
        Maximum: 'ขนาดสินค้าสูงสุด',
        TradingTime: 'เวลาการซื้อขาย',
        TradingLeverage: 'การเลเวอเรจในการซื้อขาย',
        FeeRate: 'อัตราค่าธรรมเนียม',
        Introduction: 'แนะนำ',
        IssuanceDate: 'วันที่เผยแพร่',
        TotalIssuance: 'การเผยแพร่ทั้งหมด',
        CirculatingSupply: 'การเผยแพร่ในระบบ',
        Crowdfunding: 'ราคาในการระดมทุน',
        Whitepaper: 'เอกสาร Whitepaper',
        Official: 'เว็บไซต์อย่างเป็นทางการ',
        Blockchain: 'เครื่องมือสำรวจบล็อกเชน',
        Positions: 'ตำแหน่ง',
        OpenOrder: 'คำสั่งซื้อที่เปิดอยู่',
        TradeHistory: 'ประวัติการซื้อขาย',
        ProfitLoss: 'กำไร/ขาดทุน',
        CloseAll: 'ปิดทั้งหมด',
        Contract: 'สัญญา',
        LotSize: 'ขนาดสัญญา',
        OpeningPrice: 'ราคาเปิดตำแหน่ง',
        CurrentPrice: 'ราคาปัจจุบัน',
        TakeProfi: 'ราคาที่จะเอากำไร',
        StopLoss: 'ราคาที่จะตัดขาดทุน',
        OrderPL: 'กำไร/ขาดทุนของคำสั่งซื้อ',
        OpeningTime: 'เวลาที่เปิดตำแหน่ง',
        OrderID: 'หมายเลขคำสั่งซื้อ',
        Action: 'การดำเนินการ',
        Settings: 'การตั้งค่า',
        ClosePosition: 'ปิด',
        Delete: 'ลบ',
        Status: 'สถานะ',
        EnterCurrency: 'โปรดป้อนสกุลเงิน',
        saveStopLoss: 'ตั้งค่า T/P และ S/L',
        live:'สด',
        demo:'การสาธิต'
    },
    SpotGoods:{
        pricelimit: 'ราคาจำกัด',
        marketprice: 'ราคาตลาด',
        Price: 'ราคา',
        MarketPrice: 'ราคาตลาด',
        PleaseEnter: 'โปรดป้อน',
        Quantity: 'ปริมาณ',
        Total: 'รวม',
        Or: 'หรือ',
        OpenOrders: 'คำสั่งซื้อที่เปิดอยู่',
        Fee: 'ค่าธรรมเนียม',
        QuantityAcc: 'ปริมาณการซื้อขายรวม',
        LatestTrade: 'การซื้อขายล่าสุด',
        Time: 'เวลา',
        NowOrders: 'คำสั่งซื้อที่เปิดอยู่',
        AllOrders: 'คำสั่งซื้อทั้งหมด',
        OrderHistory: 'ประวัติคำสั่งซื้อ',
        Date: 'วันที่',
        TradingPair: 'คู่การซื้อขาย',
        OrderType: 'ประเภทคำสั่งซื้อ',
        MarketOrder: 'คำสั่งตลาด',
        LimitOrder: 'คำสั่งราคาจำกัด',
        Direction: 'ทิศทาง',
        OrderPrice: 'ราคาคำสั่งซื้อ',
        OrderQuantity: 'ปริมาณคำสั่งซื้อ',
        OrderAmoun: 'จำนวนคำสั่งซื้อ'
    },
    Binary:{
        GameRules: 'กฎเกม',
        Trading: 'การซื้อขายกำลังดำเนินการ',
        PositionClosed: 'ปิดตำแหน่ง',
        BuyLong: 'ซื้อแบบ Long',
        BuyShort: 'ซื้อแบบ Short',
        OrderPeriod: 'ระยะเวลาคำสั่งซื้อ',
        TradingAmount: 'จำนวนการซื้อขาย',
        Estimated: 'เวลาปิดโดยประมาณ',
        ClosingTime: 'เวลาปิด',
        PlaceBet: 'วางเดิมพัน',
        Amount: 'จำนวน',
        Balance: 'ยอดเงินคงเหลือในบัญชี',
        Odds: 'อัตราส่วน',
        Profit: 'กำไรโดยประมาณ',
        Bullish: 'ตลาดขาขึ้น',
        Bearish: 'ตลาดขาลง',
        countTime: 'นับถอยหลัง',
        customInp: 'จำนวนที่กำหนดเอง'
    },
    follow:{
        Ranking: 'อันดับผู้เทรด',
        Updates: 'อัพเดตข้อมูลทุก 2 ชั่วโมง',
        SearchKey: 'ค้นหาผู้เทรดทั้งหมด',
        Search: 'ค้นหา',
        Manage: 'จัดการผู้ติดตาม',
        Details: 'รายละเอียด',
        test1: 'สูตร = คัดลอกคำสั่ง [กำไร/ขาดทุน] / [มาร์จิ้นรวม] * 100%',
        title1: 'ผลผลิต 30 วัน',
        test2: 'สูตร = คำสั่งที่วางเอง [จำนวนคำสั่งที่มีกำไร / จำนวนคำสั่งทั้งหมด] * 100%',
        title2: 'อัตราชนะในช่วง 30 วัน',
        title3: 'ผู้ติดตามปัจจุบัน',
        title4: 'คอมมิชชั่นในช่วง 30 วัน',
        test5: 'จำนวนคำสั่ง (ที่วางเอง) ในช่วง 30 วันที่ผ่านมา',
        title5: 'ข้อตกลง 30 วัน',
        test6: 'คำนวณจากวันที่ลงทะเบียน',
        title6: 'วันที่ซื้อขาย',
        Unfollow: 'เลิกติดตาม',
        Followed: 'ติดตามแล้ว',
        EditCopying: 'แก้ไขการคัดลอก',
        CopyingCurrency: 'สกุลเงินที่คัดลอก',
        AmountCopying: 'จำนวนที่คัดลอก',
        CopyingAmount: 'จำนวนที่คัดลอก',
        ContractTrading: 'คู่การซื้อขายสัญญา',
        LotSizeRatio: 'อัตราส่วนขนาดสัญญา',
        StartCopying: 'เริ่มคัดลอก',
        CancelCopying: 'ยกเลิกการคัดลอก',
        title7: 'ค่าเสียงที่ต่ำสุดในช่วง 30 วัน',
        test7: 'อัตราส่วนของสินทรัพย์ที่สูญเสียในช่วง 30 วันที่ผ่านมา (เปอร์เซ็นต์ของสินทรัพย์ที่สูญเสียในแต่ละวันต่อสินทรัพย์ของวันก่อนหน้า โดยอิงจากสูญเสียสูงสุด)',
        BackLobby: 'กลับสู่หน้าหลัก',
        TradeHistory: 'ประวัติการซื้อขาย',
        ClosingPrice: 'ราคาปิด',
        info: 'โปรไฟล์ส่วนตัว',
        CumulativeCopying: 'ยอดคัดลอกสะสม',
        TotalCopying: 'กำไรที่คัดลอกทั้งหมด',
        Discover: 'ค้นพบผู้เชี่ยวชาญ',
        CopyOrders: 'คำสั่งคัดลอก',
        CurrentFollowers: 'ผู้ติดตามปัจจุบัน',
        Avatar: 'รูปประจำตัว',
        TraderName: 'ชื่อผู้เทรด',
        MaximumPosition: 'จำนวนตำแหน่งสูงสุด',
        ProfitLoss: 'กำไร/ขาดทุนจากการคัดลอก',
        Edit: 'แก้ไข',
        TodayProfit: 'กำไรวันนี้',
        Past7Days: 'กำไรรวมในช่วง 7 วันที่ผ่านมา',
        Accumulated: 'กำไรรวมสะสม',
        ProfitDetails: 'รายละเอียดกำไร',
        Followers: 'ผู้ติดตาม',
        Profit: 'กำไร',
        FollowerAvatar: 'รูปประจำตัวของผู้ติดตาม',
        FollowerNickname: 'ชื่อเล่นของผู้ติดตาม',
        CopyingTime: 'เวลาคัดลอก',
        Notice: 'ประกาศ',
        NoticeTest1: 'คุณยังไม่ได้เป็นผู้เทรด ดังนั้นคุณไม่สามารถดำเนินการนี้ได้!',
        NoticeTest2: 'อยู่ระหว่างการตรวจสอบ โปรดรอด้วยความอดทน!',
        Cancel: 'ยกเลิก',
        ApplyNow: 'สมัครเลย',
        ApplyTrader: 'สมัครเป็นผู้เทรด',
        Nickname: 'ชื่อเล่น (ต้องการ)',
        Phone: 'หมายเลขโทรศัพท์ (ต้องการ)',
        Email: 'อีเมล (ตัวเลือก)',
        test1: 'หลังจากส่งใบสมัครแล้ว เจ้าหน้าที่ของเราจะติดต่อคุณโดยเร็วที่สุด โปรดให้ข้อมูลการสมัครที่จำเป็นตามที่ร้องขอ',
        test2: 'ในระหว่างรอการตรวจสอบ โปรดให้แน่ใจว่าไม่มีเงื่อนไขดังต่อไปนี้ มิเช่นนั้นการตรวจสอบจะล้มเหลว: ถือตำแหน่ง, คำสั่งปัจจุบัน, แผนปัจจุบัน และผู้เทรดที่กำลังติดตาม',
        Apply: 'สมัคร'
    },
    account:{
        Overview: 'ภาพรวม',
        Security: 'ความปลอดภัย',
        UserID: 'รหัสผู้ใช้',
        Welcome: 'ยินดีต้อนรับสู่ aaaa!',
        Welcometest: 'เหลืออีกไม่กี่ขั้นตอนแล้วคุณก็พร้อมที่จะเริ่มต้น',
        Registration: 'การลงทะเบียนบัญชี',
        SecurityVerification: 'การตรวจสอบความปลอดภัย',
        GotoBind: 'ไปยังการผูกข้อมูล',
        QuickBuy: 'ซื้อเหรียญด่วน',
        AssetDetails: 'รายละเอียดสินทรัพย์',
        Deposit: 'ฝากเงิน',
        Withdraw: 'ถอนเงิน',
        Transfer: 'โอนเงิน',
        TransferList: 'ประวัติการโอน',
        type: 'ประเภท',
        SpotAccount: 'บัญชีสแป็ต',
        FuturesAccount: 'บัญชีฟิวเจอร์',
        HideAsset: 'ซ่อนการประเมินสินทรัพย์',
        Available: 'ยอดเงินที่ใช้ได้ (USDT)',
        checkdetails: 'สำหรับปริมาณสินทรัพย์ที่ละเอียดโปรดตรวจสอบรายละเอียดสินทรัพย์',
        Recommendations: 'คำแนะนำด้านความปลอดภัย',
        PasswordSet: 'ตั้งค่ารหัสผ่าน',
        Change: 'เปลี่ยน',
        FundPassword: 'รหัสผ่านกองทุน',
        GotoSet: 'ไปที่การตั้งค่า',
        AddressManagement: 'จัดการที่อยู่',
        GotoAdd: 'ไปที่การเพิ่ม',
        Verification: 'การตรวจสอบตัวตน',
        GotoVerify: 'ไปยังการตรวจสอบ',
        LatestNews: 'ข่าวล่าสุด',
        SafetyTitle: 'การยืนยันสองปัจจัย',
        SafetyTest: 'เพื่อป้องกันบัญชีของคุณ แนะนำให้ทำการตรวจสอบชื่อจริงอย่างน้อยหนึ่งครั้ง',
        SafetyText1: 'ใช้สำหรับการจัดการรหัสผ่านในการเข้าสู่ระบบของบัญชี',
        SafetyText2: 'ใช้สำหรับการจัดการรหัสผ่านกองทุนของบัญชี',
        NotSet: 'ยังไม่ได้ตั้งค่า',
        Set: 'ตั้งค่า',
        SafetyText3: 'ปกป้องความปลอดภัยในการซื้อขายและบัญชีของคุณ',
        SafetyText4: 'รับรองความถูกต้องของที่อยู่สำหรับการถอนเงิน',
        Manage: 'จัดการ',
        InvitationLink: 'ลิงก์เชิญ',
        copyInvitationLink: 'สำเนา',
        InvitationCode: 'รหัสเชิญ',
        copyInvitationCode: 'สำเนา',
        enterInvitationCode: 'โปรดป้อนรหัสเชิญ'
    },
    finance:{
        Protocol: 'เครือข่ายหลัก (โปรโตคอล)',
        DepositAddress: 'ที่อยู่การฝากเงิน',
        QRCode: 'รหัส QR สำหรับการฝากเงิน',
        DepositTest1: 'ยอดฝากขั้นต่ำต่อครั้งต้องไม่น้อยกว่า',
        DepositTest2: 'บาท จำนวนที่ต่ำกว่านี้จะไม่สำเร็จ',
        DepositTest3: 'ก่อนที่จะทำการฝากเงินทุกครั้ง คุณต้องไปที่หน้านี้เพื่อคัดลอกที่อยู่เพื่อให้แน่ใจว่าถูกต้อง การใช้ที่อยู่ที่ไม่ถูกต้องอาจฝากเงินไม่สำเร็จ',
        DepositTest4: 'อย่าฝากสินทรัพย์ที่ไม่ใช่',
        DepositTest5: 'ไปยังที่อยู่ด้านบนนี้ มิเช่นนั้นทรัพย์สินจะไม่สามารถกู้คืนได้',
        WithdrawalAddress: 'ที่อยู่การถอนเงิน',
        AddressManagement: 'การจัดการที่อยู่',
        Memo: 'ข้อความอธิบาย',
        WithdrawalAmount: 'จำนวนเงินที่ถอน',
        AvailableBalance: 'ยอดเงินคงเหลือที่ใช้ได้',
        Withdraw: 'ถอน',
        WithdrawTest1: 'โปรดยืนยันว่าที่อยู่การถอนเงินที่เป้าหมายมีอยู่และได้เปิดใช้งาน มิฉะนั้นจะทำให้การถอนเงินล้มเหลวและสินทรัพย์จะไม่สามารถกู้คืนได้',
        WithdrawTest2: 'หากมีแท็กที่อยู่ โปรดตรวจสอบแท็กที่อยู่อย่างรอบคอบเพื่อป้องกันการสูญเสียทรัพย์สินที่ไม่สามารถกู้คืนได้',
        WithdrawTest3: 'เพื่อให้มั่นใจในความปลอดภัยของเงินทุน เมื่อกลยุทธ์ความปลอดภัยของบัญชีของคุณเปลี่ยนแปลงหรือรหัสผ่านถูกแก้ไข เราจะทำการตรวจสอบการถอนเงินด้วยวิธีดัดแปลง โปรดรอด้วยความอดทนให้เจ้าหน้าที่ของเราติดต่อคุณทางโทรศัพท์หรืออีเมล',
        WithdrawTest4: 'โปรดให้ความสำคัญในเรื่องความปลอดภัยของคอมพิวเตอร์และเบราว์เซอร์ของคุณเพื่อป้องกันการปรับเปลี่ยนข้อมูลหรือการรั่วไหลของข้อมูล',
        WithdrawTest5: 'เวลาที่สามารถถอนเงินได้ (UTC+8): จันทร์ถึงอาทิตย์ เวลา 9:00-22:00',
        AvailableAssets: 'สินทรัพย์ที่มีอยู่',
        GamblingAccount: 'บัญชีสอง',
        notpassword: 'คุณยังไม่ได้ตั้งค่ารหัสผ่านกองทุน ดังนั้นคุณไม่สามารถดำเนินการนี้ได้!',
        Back: 'กลับ',
        AddAddress: 'เพิ่มที่อยู่ใหม่',
        SelectCurrency: 'เลือกสกุลเงิน',
        Confirm: 'ยืนยัน',
        from: 'จาต่อไป'
    },
    assets:{
        ContractPositions: 'ตำแหน่งสัญญา',
        DepositDetails: 'รายละเอียดการฝากเงิน',
        WithdrawalHistory: 'ประวัติการถอนเงิน',
        WithdrawalRecords: 'บันทึกการฝากและถอนเงิน',
        TotalEquivalent: 'มูลค่าเทียบเท่ารวมของสินทรัพย์สแป็ตทั้งหมด (ใน USDT)',
        AvailableBalance: 'ยอดเงินคงเหลือที่ใช้ได้ในสแป็ต (USDT)',
        HideSmall: 'ซ่อนสินทรัพย์เล็ก',
        Equivalent: 'ค่าเทียบเท่า',
        FrozenAmount: 'จำนวนที่ถูกล็อค',
        DepositType: 'ประเภทการฝากเงิน',
        DepositAmount: 'จำนวนเงินที่ฝาก',
        DepositCurrency: 'สกุลเงินที่ฝาก',
        DepositTime: 'เวลาที่ฝาก',
        WithdrawalType: 'ประเภทการถอนเงิน',
        WithdrawalAmount: 'จำนวนเงินที่ถอน',
        WithdrawalCurrency: 'สกุลเงินที่ถอน',
        WithdrawalTime: 'เวลาที่ถอน'
    },
    fastChange:{
        Sell: 'ขาย',
        ReferencePrice: 'ราคาอ้างอิง',
        Buy: 'ซื้อ',
        Quantity: 'จำนวนที่สามารถแลกเปลี่ยนได้',
        PleaseEnter: 'โปรดป้อนจำนวนแลกเปลี่ยนที่ต้องการ',
        Exchange: 'แลกเปลี่ยน',
        Trading: 'แลกเปลี่ยนจำนวนเล็ก ● การซื้อขายจำนวนมาก',
        TradingTest: 'แลกเปลี่ยนรวดเร็วสำหรับ BTC, ETH และสกุลเงินดิจิตอล',
        Step1: 'ขั้นตอนที่ 1',
        Step1Test: 'เลือกสกุลเงินที่ต้องการแลกเปลี่ยน',
        Step2: 'ขั้นตอนที่ 2',
        Step2Test: 'ป้อนจำนวนที่ต้องการแลกเปลี่ยน',
        Step3: 'ขั้นตอนที่ 3',
        Step3Test: 'เริ่มแลกเปลี่ยน'
    },
    Password:{
        ChangePassword: 'เปลี่ยนรหัสผ่านการเข้าสู่ระบบ',
        OldPassword: 'รหัสผ่านการเข้าสู่ระบบเดิม',
        enterOldPassword: 'โปรดป้อนรหัสผ่านการเข้าสู่ระบบเดิมของคุณ',
        NewLogin: 'รหัสผ่านการเข้าสู่ระบบใหม่',
        enterNewLogin: 'โปรดป้อนรหัสผ่านการเข้าสู่ระบบของคุณ',
        againenterNewLogin: 'โปรดป้อนรหัสผ่านการเข้าสู่ระบบของคุณอีกครั้ง',
        FundPassword: 'ตั้งรหัสผ่านกองทุน',
        fundpassword: 'โปรดป้อนรหัสผ่านกองทุนของคุณ',
        againfundpassword: 'โปรดป้อนรหัสผ่านกองทุนของคุณอีกครั้ง',
        Name: 'ชื่อ',
        Number: 'หมายเลขประจำตัว',
        photos: 'โปรดอัปโหลดรูปบัตรประชาชน รูปแรกคือด้านหน้า และรูปที่สองคือด้านหลัง',
        photos2: 'กรุณาอัพโหลดรูปถ่ายประจำตัวของคุณ',
        Upload: 'อัปโหลด',
        wait: 'กำลังตรวจสอบ โปรดรอ!',
        categoryType:'ประเภทเอกสาร',
        category1:'บัตรประจำตัวประชาชน',
        category2:'หนังสือเดินทาง',
        category3:"ใบขับขี่"
    },
    add:{
        Copied:"คัดลอก!",
        test29: "การซื้อขายจำลองสิ้นสุดลง การซื้อขายจริงรองรับคุณ!",
        test30: "เติมเงินตอนนี้และเพลิดเพลินกับรางวัลกองทุนการซื้อขาย",
        test31: "รับการสนับสนุนและเครื่องมือเพิ่มเติมทันที",
        test32: "เติมเงินเพื่อเริ่มต้นการเดินทางที่รวดเร็วของคุณ",
        DemoTrade:"การค้าสาธิต",
        Progress: "กำลังดำเนินการ",
        Requested: "ขอคืนเงิน",
        Refunded: "คืนเงินแล้ว",
        Completed: "เสร็จสมบูรณ์",
        test1: "ภาพรวมผลิตภัณฑ์",
        test2: "บริการจัดการทางการเงิน (FMS) ของ (aaaa) เป็นผลิตภัณฑ์ที่ออกแบบมาเพื่อช่วยผู้ใช้ในการทำกำไรจากสินทรัพย์ดิจิทัลที่ว่างเปล่าในระดับที่ต่ำ สามารถเริ่มต้นใช้งานได้ง่ายดาย บริการจัดการทางการเงิน (FMS) ของ (aaaa) มีตัวเลือกที่ต่างกันให้ผู้ใช้ทำกำไรโดยการให้ยืมให้กับผู้ใช้ในตลาดการให้ยืมเงินอย่างมีการยกระดับ การทำกำไรจากการถือเหรียญง่ายๆ เป็นการล็อคเหรียญเพื่อรับรางวัล PoS หรือส่งเสริมโครงการ",
        test3: "*โปรดทราบ: รายได้จากอดีตไม่แสดงให้เห็นถึงรายได้ในอนาคต เราไม่สัญญาที่จะชดเชยเงินต้นและดอกเบี้ยภายในระยะเวลาใดๆ ในรูปแบบเงินสกุล สินค้าทางกายภาพ สิทธิมิได้หรือในรูปแบบรายได้จากทรัพย์สินใดๆอื่นๆ และเราไม่สัญญารูปแบบรายได้จากทรัพย์สินใดๆอื่นๆ",
        test4: "ปลอดภัยและเชื่อถือได้",
        test5: "(aaaa) มีระบบควบคุมความเสี่ยงอย่างเข้มงวด มีมาตรการรักษาความปลอดภัยที่มีคุณภาพสูง และโครงสร้างพื้นฐานที่ทันสมัยเพื่อความปลอดภัยของสินทรัพย์ของผู้ใช้เต็มรูปแบบ",
        test6: "การสมัครสมาชิกและการแลกเปลี่ยนที่ยืดหยุ่น",
        test7: "การสนับสนุน 24 ชั่วโมงสำหรับการสมัครสมาชิกและการแลกเปลี่ยนได้ตลอดเวลา การแลกเปลี่ยนสำหรับรายได้จากการถือเหรียญง่ายๆ เป็นการแลกเปลี่ยนทันที ในขณะที่การแลกเปลี่ยนสำหรับรายได้จากการถือเหรียญง่ายๆ เป็นการแลกเปลี่ยนที่ใช้เวลาสูงสุดถึง 30 นาที",
        test8: "บริการจัดการทางการเงินเพื่อระยะเวลาที่กำหนด (aaaa) (FMS)",
        test9: "บริการจัดการทางการเงินเพื่อระยะเวลาที่กำหนด (aaaa) (FMS) มีแหล่งที่มาของรายได้หลายแห่ง เช่น รางวัลที่ได้ผ่านการค้ำประกันและรางวัลที่อิงจากกลไกของ Proof of Stake (PoS) และรางวัลบนแพลตฟอร์ม",
        test10: "อัตราผลตอบแทนรายปีแบบสะสมคืออะไร?",
        test11: "อัตราผลตอบแทนรายปีที่สะสมคือผลตอบแทนรายปีที่คาดว่าจะได้รับจากผลิตภัณฑ์ที่คุณสมัครสมาชิกเพื่อให้ข้อมูลเท่านั้น",
        test12: "การคำนวณรายได้ที่คาดว่าจะได้รับเป็นอย่างไร?",
        test13: "รายได้ที่คาดว่าจะได้รับถูกคำนวณขึ้นอยู่กับปริมาณการสมัครสมาชิกของคุณและรายได้อ้างอิงรายปีของผลิตภัณฑ์ ให้การประมาณรายได้ที่คาดว่าจะได้รับรายวันเท่านั้น เพื่อการอ้างอิงเท่านั้น",
        test14: "เมื่อดอกเบี้ยเริ่มคิด?",
        test15: "รายได้เริ่มเก็บตั้งแต่ 12:00 (UTC+8) วันถัดจากการสมัครสมาชิก",
        test16: "เมื่อได้รับการแจกจ่ายรายได้?",
        test17: "การแจกจ่ายรายได้เริ่มต้นตั้งแต่ 12:00 (UTC+8) วันถัดจากการเริ่มคิดดอกเบี้ย",
        test18: "ทำไมผลิตภัณฑ์ที่แตกต่างกันมีระยะเวลาการได้รับคืนที่แตกต่างกัน?",
        test19: "ระยะเวลาการได้รับคืนหมายถึงเวลาที่ใช้ตั้งแต่การยืนยันการได้รับคืนจนถึงการเขียนเครดิตการได้รับคืนจริง ทรัพย์สินสำหรับรายได้จากเหรียญง่ายๆที่มีระยะเวลาที่กำหนดล่วงหน้าถูกประกันบนเชือก ต้องใช้เวลาในการได้รับคืนจากเชือก เนื่องจากทุกๆ โซ่สาธารณะดำเนินการที่แตกต่างกัน ระยะเวลาการได้รับคืนจะแตกต่างกัน",
        test20: "ฉันต้องการใช้งานให้ยุติด้วยตนเองหรือไม่เมื่อสิ้นอายุ?",
        test21: "นี้ขึ้นอยู่กับสถานการณ์ ผลิตภัณฑ์ระยะเวลาที่กำหนดล่วงหน้าทั้งหมดจะถูกตั้งค่าให้ต่ออายุโดยอัตโนมัติโดยค่าเริ่มต้น เมื่อสิ้นสุดอายุเดียวกันจะถูกต่ออายุโดยอัตโนมัติ หลังจากเปิดใช้งานการต่ออายุอัตโนมัติ การได้รับคืนจะต้องทำด้วยตนเอง คุณสามารถใช้งานคุณสมบัติการต่ออายุอัตโนมัติได้โดยค่าเริ่มต้น หากต้องการปิดใช้งาน โปรดไปที่หน้ารายละเอียดการสั่งซื้อ",
        test22: "ฉันยังสามารถรับรายได้ได้ระหว่างรอการไถ่ถอนได้หรือไม่?",
        test23: "เมื่อการไถ่ถอนได้รับการยืนยันแล้ว ดอกเบี้ยจะหยุดเพิ่มขึ้น รายได้ไม่สามารถได้รับได้ในระหว่างรอการไถ่ถอน",
        test24: "วิธีการเลือกผลิตภัณฑ์บริหารการเงินแบบฟิกซ์เทอมที่ดีที่สุดของ (aaaa) (FMS)",
        test25: "คุณสามารถเปรียบเทียบสินทรัพย์ดิจิทัลที่แตกต่างกัน เงื่อนไข ผลตอบแทนในอดีต ฯลฯ ในระหว่างผลิตภัณฑ์การทำเหรียญง่ายที่เราให้บริการทั้งหมด เพื่อเลือกผลิตภัณฑ์ที่เหมาะสมกับคุณ เราให้บริการเฉพาะการประกันสินทรัพย์ การเก็บรางวัล และการแจกจ่ายเท่านั้น และไม่ให้คำแนะนำเกี่ยวกับการลงทุน ก่อนที่จะตัดสินใจลงทุน คุณควรเข้าใจลักษณะและความเสี่ยงของผลิตภัณฑ์นี้โดยสมบูรณ์ รวมถึงสถานการณ์ที่เกี่ยวข้องอื่น ๆ และตัดสินใจอย่างอิสระตามประสบการณ์การลงทุนของคุณ สถานะทางการเงิน จุดมุ่งหมายของการลงทุน ระยะเวลาการลงทุน ความพร้อมและความสามารถในการรับความเสี่ยงของการลงทุน และสถานการณ์ที่เกี่ยวข้องอื่น ๆ และต้องรับผิดชอบต่อการตัดสินใจของตนเอง",
        test26: "รายได้",
        test27: "ข้อดี",
        test28: "คำถามที่พบบ่อย",
        assets: "ทรัพย์สินทางการเงิน",
        Redemption: "การไถ่ถอน",
        Subscribe: "สมัครสมาชิก",
        SubscribeType: "ประเภทการสมัครซื้อ",
        SubscribeNum: "จำนวนเงินที่สมัครซื้อ",
        Historical: "ดอกเบี้ยสะสม",
        SubscribeTime: "เวลาที่สมัครซื้อ",
        RedemptionTime: "เวลาการแลกคืน",
        RedemptionConfirm: "การยืนยันการแลกคืน",
        LockedSavings: "การลงทุนระยะยาว",
        test33: "การบริหารการเงิน",
        test34: "เข้าใจแนวคิดหลักและกลยุทธ์การบริหารความเสี่ยงของการลงทุนในสกุลเงินดิจิทัล รับมือกับการเปลี่ยนแปลงของตลาดอย่างมีสมาธิและประสบความสำเร็จในการตั้งเป้าหมายทางการเงิน มาเข้าร่วมเราเลยเพื่อเริ่มต้นการเดินทางของคุณในการลงทุนในสกุลเงินดิจิทัล!",
        test35: "เข้าใจกลไกของการลงทุนในสกุลเงินดิจิทัล ตีความแนวโน้มของตลาด ค้นหาโอกาสที่เป็นไปได้ และประสบความสำเร็จในการเพิ่มมูลค่าทางการเงิน ไม่มีขั้นต่ำ ความเสี่ยงต่ำ ผลตอบแทนสูง มาเริ่มต้นการเดินทางการบริหารความร่ำรวยด้วยสกุลเงินดิจิทัลและเคลื่อนไหวไปสู่ความสูงสุดของความร่ำรวย!",
        test36: "รายการผลิตภัณฑ์",
        test37: "รายการสมัครซื้อ",
        test38: "อัตราดอกเบี้ยประจำปี:",
        test39: "วัน：",
        test40: "จำนวนเงินขั้นต่ำที่สามารถลงทุนได้:",
        test41: "จำนวนเงินสูงสุด:",
        test42: "วันเริ่มต้นดอกเบี้ย:",
        test43: "วันสิ้นสุดการคำนวณดอกเบี้ย:",
        test44: "สูงสุด",
        test45: "สินทรัพย์ที่ใช้ได้:",
        test46: "กำไรโดยประมาณ:",
        test47: "ฉันได้อ่านและยอมรับ",
        test48: "ภาพรวมผลิตภัณฑ์",
        test49:"ท้องฟ้า",
        Agreement: "ข้อตกลงการซื้อขายทางการเงิน",
        test50:"จำนวนการเติมเงิน",
        test51:"อัปโหลดใบสำคัญการโอน",
        EnterPrice: "โปรดป้อนราคา",
    }
}